import Vue from 'vue'

// Utilities used in base component loader
import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'
import throttle from 'lodash/throttle'

// Global [non-scoped] stylesheet
import './assets/scss/main.scss'

// Entry point, router, store, service worker
import App from './App.vue'
import router from './router'
import store from './store'

// LocationAware plugin
import LocationAware from './plugins/LocationAware/'

// Google Tag Manager integration
import VueGtm from 'vue-gtm'

// Don't show production tip
Vue.config.productionTip = false

// Component registration: See the below URL for the basis of this.
// The strategy has been modified, but could easily be reverted.
// https://vuejs.org/v2/guide/components-registration.html#Automatic-Global-Registration-of-Base-Components
// Create a require context for Webpack to load very commonly used components
const requireComponent = require.context(
  // The relative path of the components folder
  './components',
  // Whether or not to look in subfolders
  false,
  // The regular expression used to match base component filenames
  // Currently looking for specific components.
  /ContentText|ItemList|Modal|Box|HeaderBar|FooterLogos|Surround\.(vue|js)$/
)
// Run through the list of components and register them.
requireComponent.keys().forEach(fileName => {
  // Get component config
  const componentConfig = requireComponent(fileName)

  // Get PascalCase name of component
  const componentName = upperFirst(
    camelCase(
      // Gets the file name regardless of folder depth
      fileName
        .split('/')
        .pop()
        .replace(/\.\w+$/, '')
    )
  )

  // Register component globally
  Vue.component(
    componentName,
    // Look for the component options on `.default`, which will
    // exist if the component was exported with `export default`,
    // otherwise fall back to module's root.
    componentConfig.default || componentConfig
  )
})

// Opportunistically calculate a representation of the `vh` unit.
// This becomes a CSS variable `--vh` which can be used in CSS throughout.
// This eases dealing with some phones/browsers in some situations where the
// vh unit doesn't respect the visibility of toolbars.
// https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
function realVhCalc() {
  const vh = window.innerHeight * 0.01;
  // Then we set the value in the --vh custom property to the root of the document
  document.documentElement.style.setProperty('--vh', `${vh}px`);
}
const vhCalc = throttle(realVhCalc, 300)
window.addEventListener('resize', vhCalc)
realVhCalc()

// Set up temporary exhibit store
// const exhibits = {
//   "conservatory-id": {
//     "ref": "Conservatory",
//     "name": "Conservatory",
//     "longitude": -73.88223052024843,
//     "level": "ground",
//     "latitude": 40.8637567472901,
//     "id": "conservatory-id",
//     "elevation": 0,
//     "friendly": "conservatory"
//   }
// }

// store.commit('exhibits', exhibits)

// Set up the LocationAware plugin now that we have a store for it to feed
Vue.use(LocationAware, {
  store: store
})

// Register GTM integration with router
if (process.env.VUE_APP_GTM_ID) {
  Vue.use(VueGtm, {
    id: process.env.VUE_APP_GTM_ID,
    vueRouter: router
  })
}

// Preload exhibit info and kickstart the app
store.dispatch('refreshExhibits').then(() => {
  // Set up the main Vue instance after registering base components
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
})

